import Tdg_AddressModelBase from '../_generated/modelBases/tdg-address-model-base';

export default class Tdg_AddressModel extends Tdg_AddressModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
